import { API_URL } from 'constants';

export const DEFAULT_TEAM_URL = `${API_URL}/api/v1/team`;
